import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id },
          { withCredentials: true }
        );
        setUser(data);
        navigate("/admin", { replace: true });
      } catch {
        navigate("/login?err=1", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[rgb(var(--page))]">
      <div className="flex items-center gap-2 text-ink-2">
        <Loader2 className="h-5 w-5 animate-spin text-orange-500" />
        <span className="font-semibold">Signing you in…</span>
      </div>
    </div>
  );
}
